import React from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { DENOMINACIONES } from "../constants";

interface FondoStepProps {
  denominaciones: Record<number, string>;
  totalEfectivo: number;
  notaFondos: string;
  onDenominacionChange: (valor: number, cantidad: string) => void;
  onNotaChange: (valor: string) => void;
}

const FondoStep = ({ denominaciones, totalEfectivo, notaFondos, onDenominacionChange, onNotaChange }: FondoStepProps) => (
  <Row className="g-4">
    <Col xl="6">
      <Card className="h-100">
        <CardBody>
          <h5 className="mb-2">Detalle de efectivo</h5>
          <div className="table-responsive">
            <Table borderless className="align-middle table-sm mb-0">
              <thead>
                <tr>
                  <th>Denominación</th>
                  <th className="text-end">Cantidad</th>
                  <th className="text-end" style={{ width: 160 }}>
                    Subtotal
                  </th>
                </tr>
              </thead>
              <tbody>
                {DENOMINACIONES.map((valor) => {
                  const cantidad = denominaciones[valor] ?? "0";
                  const subtotal = valor * Number(cantidad);
                  return (
                    <tr key={valor}>
                      <td>Gs. {valor.toLocaleString("es-PY")}</td>
                      <td className="text-end" style={{ width: 140 }}>
                        <Input
                          type="number"
                          min="0"
                          value={cantidad}
                          onChange={(event) => onDenominacionChange(valor, event.target.value)}
                        />
                      </td>
                      <td className="text-end" style={{ width: 160 }}>
                        Gs. {subtotal.toLocaleString("es-PY")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={2}>Total efectivo</th>
                  <th className="text-end">Gs. {totalEfectivo.toLocaleString("es-PY")}</th>
                </tr>
              </tfoot>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
    <Col xl="6">
      <Card className="h-100">
        <CardBody>
          <h5 className="mb-3">Notas internas</h5>
          <FormGroup>
            <Label for="notaFondos">Detalle adicional del fondo</Label>
            <Input
              id="notaFondos"
              type="textarea"
              rows={8}
              value={notaFondos}
              onChange={(event) => onNotaChange(event.target.value)}
              placeholder="Ej: fondo separado para cambios y ajustes."
            />
          </FormGroup>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

export default FondoStep;
